import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RowAction } from './data-table.types';

export interface UiDataTableActionMenuState {
  row: unknown;
  rowIndex: number;
  top: number;
  left: number;
  openAbove?: boolean;
  items: readonly RowAction[];
}

@Component({
  selector: 'ui-data-table-actions-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  templateUrl: './data-table-actions-menu.component.html',
  styleUrl: './data-table-actions-menu.component.scss',
})
export class UiDataTableActionsMenuComponent {
  readonly state = input.required<UiDataTableActionMenuState>();
  readonly items = input.required<readonly RowAction[]>();

  readonly actionSelect = output<RowAction>();
}

